var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 178,
    viewBox: "0 0 167 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_212_5)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8206 23.5114C66.2964 22.0437 68.719 22.1456 69.9622 23.8148C71.4173 25.7685 72.7657 27.8094 73.9988 29.9297C80.4028 40.9409 83.4105 53.5963 82.6412 66.2951C81.8719 78.994 77.3602 91.1663 69.6768 101.273C61.9934 111.379 51.4834 118.965 39.4759 123.072C28.5864 126.797 16.9089 127.508 5.66614 125.165C3.7473 124.765 2.6198 122.813 3.11749 120.918L6.51503 107.975C7.01548 106.069 8.96876 104.948 10.9082 105.299C18.2131 106.62 25.7484 106.063 32.7985 103.652C40.9767 100.855 48.1351 95.6877 53.3681 88.8044C58.6012 81.9212 61.674 73.6307 62.1979 64.9816C62.722 56.3327 60.6735 47.7132 56.3117 40.2136C55.8417 39.4053 55.347 38.6139 54.8288 37.8405C53.8269 36.3453 53.9409 34.3313 55.2171 33.0622L64.8206 23.5114Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2005 4.23843C46.0727 3.21839 42.6089 1.99319 40.0027 1.12172C38.0972 0.484544 36.0697 1.59689 35.5388 3.53472L32.0617 16.2255C31.5538 18.0792 32.6097 20.0002 34.4274 20.6248C36.0418 21.1795 37.8976 21.8606 39.1133 22.4433C40.476 23.0966 41.7976 23.8188 43.0736 24.6058C44.6886 25.6019 46.8224 25.3395 48.0176 23.8658L56.4186 13.5072C57.6893 11.9404 57.4099 9.62299 55.7283 8.50878C53.3322 6.92115 50.818 5.49317 48.2005 4.23843Z",
    fill: "#B6EC1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.841 171.108C135.359 173.083 133.324 174.25 131.39 173.627C128.745 172.775 125.237 171.578 123.072 170.572C111.554 165.216 101.885 156.564 95.2888 145.712C88.6927 134.859 85.4652 122.293 86.0146 109.602C86.5639 96.9114 90.8652 84.666 98.3749 74.4145C105.885 64.163 116.265 56.3656 128.204 52.0087C139.025 48.0596 150.685 47.0976 161.965 49.1903C163.899 49.549 165.068 51.4861 164.602 53.3965L161.429 66.382C160.963 68.2903 159.039 69.4446 157.099 69.1363C149.765 67.9708 142.233 68.6879 135.219 71.2477C127.088 74.2152 120.017 79.5261 114.903 86.5082C109.788 93.4904 106.859 101.831 106.484 110.474C106.11 119.118 108.308 127.676 112.801 135.068C117.294 142.459 123.879 148.352 131.724 152C132.987 152.587 134.921 153.27 136.582 153.818C138.386 154.413 139.463 156.286 139.012 158.131L135.841 171.108Z",
    fill: "#DCDCDC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_212_5",
    x: 0.986368,
    y: 0.94165,
    width: 165.731,
    height: 176.881,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.01363
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.00682
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.3875 0 0 0 0 0.3875 0 0 0 0 0.3875 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_212_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_212_5",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIc);
export default __webpack_public_path__ + "static/media/logoIC.a35bb55809cd6296a498ddf7c6400191.svg";
export { ForwardRef as ReactComponent };